import { InputLabel, FormControl, Button } from '@mui/material';

import { MySelect, MyMenuItem } from "~/mui/MySelect";
import TextFieldEnter from "~/mui/TextFieldEnter";
import { useTrans } from '~/hooks/useTrans';
import { myUseState } from "~/hooks/myUseState";
import { IAdminJournalItem } from "~/providers/admin-interfaces";

export type TFilter = "email" | "none";
export type TFilterAction = IAdminJournalItem["action"] | "all";

interface IState {
	filterType: TFilter;
	filterValue: string;
	filterValueDisabled: boolean;
	filterRoleType: TFilterAction;
}

interface IAdminJournalFilter {
	onFilter: (filterType: TFilter, filterRole: TFilterAction, filterValue: string) => void;
}

export default function AdminJournalFilter({
	onFilter = () => {},
}: IAdminJournalFilter) {
	const { state, setState, updateState } = myUseState<IState>({
		filterType: "none",
		filterValue: "",
		filterValueDisabled: true,
		filterRoleType: "all",
	});
	const { trans } = useTrans();

	function updateFilter(value: TFilter) {
		const disabledTypes: Array<TFilter> = ["none"];
		const filterValueDisabled = disabledTypes.indexOf(value) !== -1;

		setState(prev => ({
			...prev,
			filterType: value,
			filterValue: filterValueDisabled ? "" : prev.filterValue,
			filterValueDisabled,
		}));
	}

	function sendFilter() {
		onFilter(state.filterType, state.filterRoleType, state.filterValue);
	}

	return <>
		<FormControl size="small">
			<InputLabel>{ trans("adminInternalUsersPage.filter.title") }</InputLabel>
			<MySelect
				value={state.filterType}
				onChange={event => updateFilter(event.target.value as TFilter)}
				label={ trans("adminInternalUsersPage.filter.title") }
			>
				<MyMenuItem value="email">{ trans("adminInternalUsersPage.filter.types.email") }</MyMenuItem>
				<MyMenuItem value="none">{ trans("adminInternalUsersPage.filter.types.none") }</MyMenuItem>
			</MySelect>
		</FormControl>
		<TextFieldEnter
			label={trans("adminInternalUsersPage.filter.filterValue")}
			value={state.filterValue}
			onEnter={() => sendFilter()}
			onChange={event => updateState({ filterValue: event.target.value })}
			color="success"
			size="small"
			disabled={state.filterValueDisabled}
			sx={{ backgroundColor: "#fff" }}
		/>
		<FormControl size="small">
			<InputLabel>{ trans("adminJournalsTable.roleAction.title") }</InputLabel>
			<MySelect
				value={state.filterRoleType}
				onChange={event => updateState({ filterRoleType: event.target.value as TFilterAction })}
				label={ trans("adminJournalsTable.roleAction.title") }
			>
				<MyMenuItem value="DELETE">{ trans("adminJournalsTable.roleAction.delete") }</MyMenuItem>
				<MyMenuItem value="INSERT">{ trans("adminJournalsTable.roleAction.insert") }</MyMenuItem>
				<MyMenuItem value="UPDATE">{ trans("adminJournalsTable.roleAction.update") }</MyMenuItem>
				<MyMenuItem value="all">{ trans("adminJournalsTable.roleAction.all") }</MyMenuItem>
			</MySelect>
		</FormControl>
		<Button color="success" variant="contained" onClick={sendFilter}>
			{ trans("filter") }
		</Button>
	</>;
}
